export default {"src":"/_next/static/media/logo.eac6215d.svg","height":40,"width":43};